import React from "react";
import "./Hero.css";

const Hero = () => (
  <section className="hero scroll-panel">
    <h1>📜 The Codex of Backendia</h1>
    <p className="hero-quote">
      "A tale of one developer’s journey through the realms of code."
    </p>
    <p className="hero-intro">
      Welcome traveler, to Backendia — a realm where code is conjured, systems
      are tamed, and bugs are vanquished. You now stand before The Architect,
      backend sorcerer on an endless quest for scalable perfection.
    </p>
  </section>
);

export default Hero;
